<script lang="ts">
</script>

<a
  href="/subscribe/racing"
  class="group flex w-full items-center justify-between bg-gradient-to-r from-purple-800 via-purple-800 to-indigo-500 px-4 py-2 text-white transition duration-500 hover:from-purple-700 hover:via-purple-700 hover:to-indigo-500"
>
  <div>
    <h2 class="text-md font-bold md:text-lg">
      Start Your 7 Day Free Trial of Betwatch Premium
    </h2>
    <p class="text-xs md:text-sm">
      Get all racing prices, betslip automation, live updates, fluctuations,
      realtime alerts, historic prices and more!
    </p>
  </div>
  <div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      class="h-6 w-6 group-hover:text-white"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M9 5l7 7-7 7"
      />
    </svg>
  </div>
</a>

<!-- <div
  role="button"
  tabindex="0"
  on:click={handleClick}
  on:keypress={handleClick}
  class="flex w-full md:m-2 cursor-pointer flex-col items-center justify-between gap-x-6 bg-gradient-to-r from-purple-800 via-purple-800 to-indigo-500 px-6 py-2.5 text-white hover:from-purple-700 hover:via-purple-700 hover:to-indigo-500 sm:rounded-xl sm:px-2 sm:py-3 sm:pl-4 sm:pr-3.5"
>
  <p class="flex w-full flex-row items-center text-xs leading-6 sm:text-sm">
    <span class="flex-1 flex-col"
      ><strong class="font-semibold">Upgrade to Betwatch Premium</strong><svg
        viewBox="0 0 2 2"
        class="mx-2 hidden h-0.5 w-0.5 fill-current sm:inline"
        aria-hidden="true"><circle cx="1" cy="1" r="1" /></svg
      ><strong class="hidden sm:inline"
        >Click here to start your free 7 day trial</strong
      >
      <div>
        <span class=""
          >Get all racing prices, live updates, fluctuations, alerts, historic
          prices and more for $29/month.</span
        >&nbsp;
      </div>
    </span>
    <span class="flex-0" aria-hidden="true"> &rarr; </span>
  </p>
</div> -->
